import type { GetListingResponseBody, JsonObject } from '@/app-package';
import Axios from 'axios';

export type Listing = JsonObject<
  GetListingResponseBody & { isUnclaimed?: boolean }
>;

const getListing = async (listingId: string) => {
  const { data } = await Axios.get<Listing>(`/listing/${listingId}`);
  return data;
};

export default getListing;
